const statusColors = {
  ordered: "background-color: #e0f2fe; color: #1e40af; border-color: #bfdbfe;",
  pending: "background-color: #fefce8; color: #b45309; border-color: #fde68a;",
  shipped: "background-color: #ecfdf5; color: #15803d; border-color: #a7f3d0;",
  "ready for shipment":
    "background-color: #f5f3ff; color: #6d28d9; border-color: #ddd6fe;",
  completed:
    "background-color: #ccfbf1; color: #0f766e; border-color: #99f6e4;",
  confirmed:
    "background-color: #e0f2fe; color: #1e40af; border-color: #bfdbfe;",
  processing:
    "background-color: #fefce8; color: #b45309; border-color: #fde68a;",
  canceled: "background-color: #fef2f2; color: #b91c1c; border-color: #fecaca;",
  all: "background-color: #f9fafb; color: #374151; border-color: #d1d5db;",
};

function statusBadge(status) {
  const normalizedStatus = status.toLowerCase();
  const color =
    statusColors[normalizedStatus] ||
    "background-color: #f9fafb; color: #374151; border-color: #d1d5db;";
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "0.25rem 0.75rem",
        borderRadius: "9999px",
        fontSize: "0.75rem",
        fontWeight: 600,
        border: "1px solid",
        ...Object.fromEntries(
          color
            .split(";")
            .map((s) => s.trim().split(":"))
            .filter(([k]) => k)
        ),
      }}
    >
      <span
        style={{
          width: "0.375rem",
          height: "0.375rem",
          borderRadius: "50%",
          marginRight: "0.375rem",
          backgroundColor:
            normalizedStatus === "shipped"
              ? "#22c55e"
              : normalizedStatus === "pending"
              ? "#f59e0b"
              : normalizedStatus === "ordered"
              ? "#3b82f6"
              : normalizedStatus === "ready for shipment"
              ? "#8b5cf6"
              : "#6b7280",
        }}
      />
      {status}
    </span>
  );
}

export { statusBadge };
